export default __webpack_public_path__ + "05aff04785fab55ec3fc0d0792835ebe.png";